/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse.jsx";

// Data

// Dashboard components

function EditPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Title*"
                variant="outlined"
              />

              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Slug*"
                variant="outlined"
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "5vh" }}>
              <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Content*</span>
              <textarea
                placeholder="write description"
                style={{ width: "60vw", padding: "10px" }}
                name=""
                id=""
                cols="30"
                rows="10"
              ></textarea>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "5vh" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Slug*"
                variant="outlined"
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "5vh" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "60vw" }}
                label="Meta Title*"
                variant="outlined"
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "5vh" }}>
              <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Meta decsription*</span>
              <textarea
                placeholder="write description"
                style={{ width: "60vw", padding: "10px" }}
                name=""
                id=""
                cols="30"
                rows="10"
              ></textarea>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "5vh" }}>
            <TextField
              id="outlined-basic"
              sx={{ width: "60vw" }}
              label="Meta Tags*"
              variant="outlined"
            />
          </div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button title={"Submit"} />
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditPage;
